import { createContext, ReactNode, useContext, useState } from 'react'

/* eslint-disable react-refresh/only-export-components -- context module */

type LoadingContextType = {
    showLoading: (message: string) => void
    hideLoading: () => void
    isLoading: boolean
    message: string
}

const LoadingContext = createContext<LoadingContextType>({
    showLoading: () => {},
    hideLoading: () => {},
    isLoading: false,
    message: '',
})

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [message, setMessage] = useState('')

    const showLoading = (message: string) => {
        setMessage(message)
        setIsLoading(true)
    }

    const hideLoading = () => {
        setIsLoading(false)
        setMessage('')
    }

    return (
        <LoadingContext.Provider value={{ showLoading, hideLoading, isLoading, message }}>
            {children}
        </LoadingContext.Provider>
    )
}

export const useLoading = () => useContext(LoadingContext)
